<template>
  <div class="payment-wrapper">
    <div v-show="!jumpFlag" class="allcontent">
      <div class="payment-header">
        <div class="content">
          <header>
            <div class="lang">
              <span>
                <img :src="this.customizeCashierLogo" alt="Cashier Logo"/>
              </span>
              <div class="country">
              </div>
            </div>
          </header>
        </div>
      </div>
      <div class="payment-main-content">
        <div v-loading.fullscreen.lock="fullscreenLoading" class="payment-main">
          <div class="content">
            <main>
              <div class="leftcontent">
                <el-skeleton v-show="fullscreenLoading" :rows="5" animated/>
                <div v-show="!fullscreenLoading" class="left-top">
                  <div class="back">
                    <i class="el-icon-back" @click="goBack"></i>
                    <span class="name">Back</span>
                  </div>
                  <div class="order-info">
                    <p>
                      Merchant Order Number：
                      <span>{{ resData.merOrderNo ? resData.merOrderNo : '' }}</span>
                    </p>
                    <p>
                      Transaction URL：
                      <span>{{
                          resData.sourceUrl ? `${resData.sourceUrl.length > 20 ? resData.sourceUrl.substring(0, 20) + '...' : resData.sourceUrl}` : ''
                        }}</span>
                    </p>
                  </div>

                  <!-- 更多币种的时候打开 -->
                  <div class="cart-show">
                    <div v-for="(item, index) in (resData.goods || []).slice(0, 1) || ''" :key="index"
                         class="cart-total">
                      <img fetchpriority="high" :src="item.img" :alt="item.name"/>
                      <span @click="goodsDetail = !goodsDetail">{{ total }} items</span>
                    </div>
                    <p>Amount</p>
                    <div class="money">
                      <span>{{ resData.payCurrency }}</span>
                      <span>{{ resData.payAmount }}</span>
                    </div>
                  </div>
                  <div class="goods-detail">
                    <div class="detail-box">
                      <div class="details">
                        <div class="deatilLeft">
                          <div v-for="(item, index) in (resData.goods || [])" v-if="resData.goods.length > 0"
                               :key="index"
                               class="leftItem">
                            <div class="left">
                              <img :src="item.img" fetchpriority="high" :alt="item.name" class="active"/>
                              <div>
                                <h3>{{ item.name }}</h3>
                                <p>
                                  <!-- Quantity -->
                                  <span>{{ resData.payCurrency }} {{ item.price }}</span>
                                </p>
                              </div>
                            </div>
                            <div v-show="item.num !== 0" class="right">
                              <p>Qty:{{ item.num }}</p>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <p class="total-num">
                      Total：
                      <span>{{ resData.payCurrency }} {{ resData.payAmount }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="rightcontent">
                <el-skeleton v-show="fullscreenLoading" :rows="5" animated/>
                <div v-show="!fullscreenLoading" class="right-box">
                  <!-- js client started-->
                  <!-- Loading -->
                  <div id="gc-cashier-loading" class="gc-cashier-loading">
                    <div class="gc-cashier-loader" id="gc-cashier-loader"></div>
                  </div>
                  <div id="gc_pay_list_container" class="gc_pay_list_container gc-skeleton-div"></div>
                  <div id="pay_qrcode_container" class="pay_qrcode_container"></div>
                  <!-- Card form iframes  Wrapper make date and cvv in one line-->
                  <div class="payment-fields-wrapper is-loading-skeleton">
                    <div id="guaranteed_safe_checkout_container" class="guaranteed-safe-checkout">
                      <img fetchpriority="high" src="https://static.glocashier.com/v1/green-lock.svg" title="Trusted by PCI Compliance, Guaranteed safe checkout." alt="Trusted by PCI Compliance, Guaranteed safe checkout." class="checkout-lock-icon">
                      <span class="checkout-safe-text">GUARANTEED SAFE CHECKOUT</span>
                    </div>

                    <!-- Card Number -->
                    <div class="field-group">
                      <label for="gc_card_pay_container_card">Card Number</label>
                      <div id="gc_card_pay_container_card" class="gc_card_pay_container_card"></div>
                    </div>
                    <!-- Expiry Date -->
                    <div class="field-group">
                      <label for="gc_card_pay_container_date">Expiration Date</label>
                      <div id="gc_card_pay_container_date" class="gc_card_pay_container_date"></div>
                    </div>
                    <!-- CVV -->
                    <div class="field-group">
                      <label for="gc_card_pay_container_cvv2">Security Code</label>
                      <div id="gc_card_pay_container_cvv2" class="gc_card_pay_container_cvv2"></div>
                    </div>

                  </div>
                  <div id="gc_pay_mandatory_field_container" class="gc_pay_mandatory_field_container"></div>
                  <div id="pay_now_button_container" class="pay_now_button_container"></div>
                  <div id="gc_pay_notice_container" class="gc_pay_notice_container"></div>
                  <div id="gc_pay_countdown_container" class="gc_pay_countdown_container"></div>
                  <!-- js client ended-->
                  <div class="pci-div-imgLog ">
                    <img title="Trusted by PCI Compliance, Guaranteed safe checkout." alt="Trusted by PCI Compliance, Guaranteed safe checkout." src="@/assets/images/PCI-Verify.svg"/>
                  </div>
                </div>
              </div>

            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import eventUtil from "@/utils/eventCollectUtil";
import '@/assets/stytle/homepage/homepage2.css';
import {
  defaultIconLoading,
  loadCashierPage, loadCss,
} from "@/utils/homepageUtil";

import {initAWXFraud} from "@/utils/awxFraud";
import {
  JS_CLIENT_CSS_DEV,
  JS_CLIENT_CSS_PROD,
  JS_CLIENT_CSS_UAT, JS_CLIENT_URL_DEV,
  JS_CLIENT_URL_PROD,
  JS_CLIENT_URL_UAT
} from "@/utils/constant";

export default {
  name: "homePage",
  components: {
  },
  data() {
    return {
      customizeCashierLogo: require('@/assets/images/loading-icons8.gif'),
      current_env: 'TEST',
      default_icon: defaultIconLoading,
      fullscreenLoading: true,
      jsClientFraudInitialized: false,
      //请求页面数据返回
      res: {},
      //请求支付时的数据返回
      payResponse: {},
      resData: {},
      //商品总价
      totalPrice: 0,
      //商品总数
      total: 0,
      jumpFlag: false,
      //当前币种
      currentCurrency: "",
      //当前国家
      currentCountry: "",
      countryArr: "",
      goodsDetail: "",
      originURL: '',
    };
  },

  methods: {
    updateFavicon(faviconUrl) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = faviconUrl;
    },
    // 点击返回上一页
    goBack() {
      window.history.back();
    },
  },

  destroyed() {
  },

  mounted() {
    if (!document.getElementById('payment-method-template')) {
      const templateEl = document.createElement('template');
      templateEl.id = 'payment-method-template';
      templateEl.innerHTML = `
            <div class="pay_method">
                <img fetchpriority="high" src="" alt="Payment Logo" class="pay_method_logo" id="pay_method_logo">
            </div>
        `;
      document.body.appendChild(templateEl);
    }

    console.log("current_env env,", process.env.NODE_ENV);
    let jsClientURL = process.env.VUE_APP_JS_CLIENT;
    let jsClientCSSURL = process.env.VUE_APP_JS_CLIENT_CSS;
    if ("uat" === process.env.NODE_ENV) {
      jsClientURL = JS_CLIENT_URL_UAT
      jsClientCSSURL = JS_CLIENT_CSS_UAT
    } else if ("production" === process.env.NODE_ENV) {
      jsClientURL = JS_CLIENT_URL_PROD
      jsClientCSSURL = JS_CLIENT_CSS_PROD
    } else if ("development" === process.env.NODE_ENV) {
      jsClientURL = JS_CLIENT_URL_DEV
      jsClientCSSURL = JS_CLIENT_CSS_DEV
    }
    this.current_env = process.env.NODE_ENV;
    console.log("jsClientURL host", jsClientURL, " style: ",  jsClientCSSURL);
    // Create the script tag
    const script = document.createElement('script');
    script.src = jsClientURL;
    script.async = true;
    // Define what happens AFTER the script has loaded
    script.onload = () => {
      loadCss(jsClientCSSURL);
      this.tradeId = window.location.search.split("?")[1];
      if (this.tradeId) {
        loadCashierPage(this);
        // eslint-disable-next-line no-undef
        GcPayClient.GlobalPaySDK.createPayMethod(this.tradeId,
            (result) => {
              console.log("Payment started:", result);
              // this.$message.info("started.");
            },
            (result) => {
              console.log("Payment succeeded:", result);
              this.$message.info("succeeded");
            },
            (result) => {
              console.log("Payment failed:", result);
              // this.$message.info("Payment failed");
            }
        );
      } else {
        console.error("Trade ID is missing from the URL!");
      }
    };
    script.onerror = () => {
      console.error("Failed to load the JS Client SDK!");
    };
    document.body.appendChild(script);
    eventUtil.deviceCollect(this);
    const referrer = document.referrer;
    if (referrer) {
      console.log('User came from:', referrer);
      this.originURL = referrer;
    } else {
      console.log('No referrer found.');
    }
    initAWXFraud(this, process.env.NODE_ENV);
  },
  beforeDestroy() {
  },
  updated() {
  },
};
</script>

<style lang="scss" scoped>
@use '../assets/stytle/homepage/homepage-scoped';
.pci-div-imgLog {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 20px 0;
}
</style>
